<template>
<div class="screenblocker">
    <div class="letter-holder">
        <div class="l-1 letter">L</div>
        <div class="l-2 letter">o</div>
        <div class="l-3 letter">a</div>
        <div class="l-4 letter">d</div>
        <div class="l-5 letter">i</div>
        <div class="l-6 letter">n</div>
        <div class="l-7 letter">g</div>
        <div class="l-8 letter">.</div>
        <div class="l-9 letter">.</div>
        <div class="l-10 letter">.</div>
    </div>
</div>
</template>

<script lang="ts" setup>
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {onMounted, ref, Ref, watch} from "vue";
import {gsap} from "gsap";

class ScreenBlockerVue extends EventListener {

  private static blockingComponents:Ref<string[]>
  public constructor() {
    super();
    ScreenBlockerVue.blockingComponents = ref([]);
    this.addEventListener("requestScreenBlockEvent", ({ requester }) => ScreenBlockerVue.requestBlock(requester))
        .addEventListener("requestScreenBlockEndEvent", ({ requester }) => ScreenBlockerVue.releaseBlock(requester))

    watch(()=>ScreenBlockerVue.blockingComponents.value.length, (newLen, oldLen)=>{
      if(newLen>0 && oldLen === 0) {
        gsap.to(".screenblocker", {zIndex:999999, opacity:0.7, duration:0.5});
      }
      if(newLen === 0 && oldLen > 0) {
        gsap.to(".screenblocker", {zIndex:-1, opacity:0, duration:0.5});
      }
    })
  }

  public static requestBlock(requester: string) {
    if(ScreenBlockerVue.blockingComponents.value.indexOf(requester)>-1) {
      return;
    }
    ScreenBlockerVue.blockingComponents.value.push(requester);
  }

  public static releaseBlock(requester: string) {
    ScreenBlockerVue.blockingComponents.value = ScreenBlockerVue.blockingComponents.value.filter(s=>s!==requester);
  }
}
new ScreenBlockerVue();

</script>

<style scoped lang="scss">
.screenblocker {
  opacity: 0;
  z-index: -1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: black;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.active {
    z-index: 999999999;
    opacity: 0.8;
  }
}

.letter-holder {
  display: inline-block;
}

.letter {
  float: left;
  font-size: 28px;
  color: white;
}

.letter {
  animation-name: loadingF;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
  animation-direction: linear;
}

.l-1 {
  animation-delay: 0.48s;
}
.l-2 {
  animation-delay: 0.6s;
}
.l-3 {
  animation-delay: 0.72s;
}
.l-4 {
  animation-delay: 0.84s;
}
.l-5 {
  animation-delay: 0.96s;
}
.l-6 {
  animation-delay: 1.08s;
}
.l-7 {
  animation-delay: 1.2s;
}
.l-8 {
  animation-delay: 1.32s;
}
.l-9 {
  animation-delay: 1.44s;
}
.l-10 {
  animation-delay: 1.56s;
}

@keyframes loadingF {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

</style>
